import { Chip, useTheme } from "@mui/material";
import { Sparkles } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
};

export const CalculatorResultBadge: FC<Props> = ({ label }) => {
	const theme = useTheme();

	return (
		<Chip
			variant="kicker"
			icon={<Sparkles size={12} />}
			label={label}
			sx={{ alignSelf: "flex-start", mb: theme.spacingTokens.md }}
		/>
	);
};
